import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CompassIcon, FileTextIcon, LockIcon, PrinterIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, EASE } from './Shared';
import { Bamboo, Clouds, LeafSpray, LuoPan, WaterRipple } from './Decor';
const productImage = 'https://cdn.magicpatterns.com/uploads/tRp2dfwPjtskStSSqnV5yA/mockup.png';
const assurances = [{
  icon: ZapIcon,
  text: 'Acceso inmediato'
}, {
  icon: LockIcon,
  text: 'Pago 100% seguro'
}, {
  icon: FileTextIcon,
  text: '100% PDF'
}, {
  icon: ShieldCheckIcon,
  text: 'Garantía 7 días'
}, {
  icon: PrinterIcon,
  text: 'Imprimible o en tablet',
  desktopOnly: true
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-brand-rice pb-5 pt-3 md:pb-20 md:pt-14" data-id="element-160" data-mp="nb6k1klpt7kg">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-161" data-mp="3d1sbczku5nu6">
        <div className="absolute -top-24 left-1/2 h-80 w-[46rem] -translate-x-1/2 rounded-full bg-brand-jadeMist blur-[110px]" data-id="element-162" data-mp="3825ywscu0bmf" />
        <div className="animate-chi-2 absolute bottom-10 left-[6%] h-64 w-64 rounded-full bg-brand-waterMist blur-[110px]" data-id="element-163" data-mp="3j925rpk1dsw2" />
        <div className="lattice absolute inset-x-0 top-0 h-24 opacity-[0.07] md:h-40" data-id="element-164" data-mp="3o5j1p5xh9bjp" />
        <Clouds className="absolute inset-x-0 top-24 mx-auto hidden h-16 w-full max-w-4xl text-brand-silver/40 md:block" data-id="element-165" data-mp="39a38120t7hnu" />
        <Bamboo className="animate-drift-slow absolute -left-2 top-28 hidden h-64 w-24 text-brand-jade/25 lg:block" data-id="element-166" data-mp="30i18r72h87f5" />
        <Bamboo className="animate-drift absolute -right-3 top-40 hidden h-56 w-20 -scale-x-100 text-brand-jade/20 lg:block" data-id="element-167" data-mp="3599i633t3ssb" />
        <LeafSpray className="absolute -bottom-8 left-[8%] hidden h-48 w-48 text-brand-jade/15 md:block" data-id="element-168" data-mp="2qkwml78msbyc" />
        <LuoPan className="animate-compass absolute -bottom-20 right-[4%] hidden h-72 w-72 text-brand-gold/20 md:block" data-id="element-169" data-mp="2vjpzaxg3fyxg" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-170" data-mp="2hlj7nz1qmv68">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} data-id="element-171" data-mp="2ljz0wkoewzs3">
          <div className="inline-flex items-center gap-2 rounded-sm border border-brand-jade/40 bg-brand-paper px-3 py-1 md:gap-2.5 md:px-4 md:py-1.5" data-id="element-172" data-mp="na08qxnyt1dn">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-jade" aria-hidden="true" data-id="element-173" data-mp="ddnf1zsf6niw" />
            <span className="font-title text-[9px] uppercase tracking-[0.3em] text-brand-jadeDeep md:text-xs" data-id="element-174" data-mp="1b0nizplcs33d">
              Vision Digital
            </span>
          </div>

          <h1 className="mx-auto mt-2.5 max-w-5xl font-title leading-[1.03] md:mt-8" data-id="element-175" data-mp="15zzupboie0cu">
            <span className="block text-[28px] text-brand-jadeDeep md:text-[clamp(3.2rem,8vw,6rem)]" data-id="element-176" data-mp="114sw2ia3jlus">FENG SHUI</span>
            <span className="mt-0.5 block text-[28px] text-brand-cinnabar md:mt-2 md:text-[clamp(3.2rem,8vw,6rem)]" data-id="element-177" data-mp="x3h62bnb8ym2">
              NEGOCIOS<span className="align-super text-[10px] md:text-2xl" data-id="element-178" data-mp="3hqu105yp3zz2">™</span>
            </span>
          </h1>

          <WaterRipple className="mx-auto mt-2 h-4 w-28 text-brand-water/60 md:mt-6 md:h-6 md:w-56" data-id="element-179" data-mp="1xa447fpd2mk5" />

          <p className="mx-auto mt-2.5 max-w-3xl font-title text-[15px] leading-snug text-brand-wood md:mt-7 md:text-3xl" style={{
          fontSize: "22px"
        }} data-id="element-180" data-mp="21by07aom32dz">
            Transformá tu negocio en un espacio preparado para atraer movimiento, oportunidades y prosperidad
          </p>
          

          <div className="mx-auto mt-2.5 flex w-full max-w-3xl justify-center md:mt-10" data-id="element-181" data-mp="2fyr83uvsx5w5">
            <motion.img src={productImage} alt="Mockup completo de Feng Shui Negocios: los 3 tomos, los 6 bonus, checklist, fichas imprimibles y videos explicativos" initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            ease: EASE
          }} className="h-auto w-[68%] max-w-[240px] drop-shadow-2xl sm:w-[80%] sm:max-w-[420px] md:w-full md:max-w-[700px]" draggable={false} fetchPriority="high" data-id="element-182" data-mp="2ky40ev5fz564" />
          </div>

          <div className="mx-auto max-w-3xl" data-id="element-183" data-mp="4d75t1sa75zs">
            <div className="hair-rule mx-auto hidden max-w-[14rem] md:block" aria-hidden="true" data-id="element-184" data-mp="3vgngkprljrps" />
            <p className="mx-auto mt-2 flex max-w-2xl items-start justify-center gap-2 font-serif text-[12.5px] leading-snug text-brand-ink md:mt-5 md:gap-2.5 md:text-lg md:leading-relaxed" data-id="element-185" data-mp="e9tnjhpb9gxl">
              <CompassIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold md:mt-1 md:h-5 md:w-5" aria-hidden="true" data-id="element-186" data-mp="3hphbme5jt1vi" />
              <span data-id="element-187" data-mp="3csigbsa5eovq">
                3 Tomos + 6 Bonus con diagnósticos y herramientas visuales para transformar tu negocio, consultorio o
                espacio de trabajo.
              </span>
            </p>
            <CTAButton className="cta-sweep relative mt-3 overflow-hidden px-8 py-3 text-[13px] md:mt-7 md:px-12 md:py-5 md:text-lg" data-id="element-188" data-mp="3mnsneufelmgd">
              <span className="relative z-10 flex items-center gap-2" data-id="element-189" data-mp="2u0pq25mgrhrp">
                Ver pack
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-190" data-mp="19inkk74x1129" />
              </span>
            </CTAButton>
          </div>

          <ul className="mx-auto mt-3 flex max-w-4xl flex-wrap justify-center gap-x-3 gap-y-1 border-y border-brand-ink/10 py-2 md:mt-10 md:gap-x-5 md:gap-y-2.5 md:py-4" data-id="element-191" data-mp="1e9ner4mnh512">
            {assurances.map(item => {
            const Icon = item.icon;
            return <li key={item.text} className={`items-center gap-1.5 text-[10px] text-brand-inkLight md:gap-2 md:text-sm ${item.desktopOnly ? 'hidden sm:flex' : 'flex'}`} data-id="element-192" data-mp="14hhmruweenlv">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-brand-jade md:h-4 md:w-4" aria-hidden="true" data-id="element-193" data-mp="1x7pzv8c2uhtl" />
                  {item.text}
                </li>;
          })}
          </ul>

          <p className="mt-4 hidden items-center gap-2 rounded-sm border border-brand-gold/60 bg-brand-paper px-4 py-2 font-title text-[11px] uppercase tracking-[0.18em] text-brand-wood sm:inline-flex md:mt-5 md:text-xs" data-id="element-194" data-mp="1n90toctjmlt6">
            <LeafSpray className="h-4 w-4 text-brand-jade" data-id="element-195" data-mp="bw8335cho3ep" />
            El sistema visual de Feng Shui para negocios
          </p>
        </motion.div>
      </div>
    </header>;
}